import React from 'react'
import { useSelector } from 'react-redux'
import { Carousel } from 'react-bootstrap';
import { ArrowCircleLeft, ArrowCircleRightSharp } from '@mui/icons-material';
const Units = () => {
    const units = useSelector(state => state.units.payload);
    let i = 0;
  return (
    <div className='row  justify-content-center'
    id='units'
    >
        <p className='small-header mt-2 text-center'> <u>CLUB UNITS</u>  </p>
        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider my-3 col-lg-4 col-md-4 col-sm-6 col-xs-12'
            style={{
              borderRadius:'20%',
                width: '350px',
                height: '350px',
          }}
            >
            {
                units.map((unit, index) => (
                
                <Carousel.Item key={index}
                className='text-center'
                variant='dark'
                style={{
                //   height:window.innerWidth > 450? 700 : 600,
                borderRadius:'20%',
                // width: '300px',
                // height: '330px',
                // backgroundColor: 'navy',
                  
              }}
                >
                {/* <span className='col-4'> */}
                <di>
                    <img src={unit.img} width={'300px'} height={'330px'} 
                      style={{ 
                        borderRadius: '20%'
                        }}
                      />
                </di>
                <h3> {unit.title} </h3>
                
                
                  
                </Carousel.Item>
                ))
            }
        
        </Carousel>

        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider my-3 col-lg-4 col-md-4 col-sm-6 col-xs-12'
            style={{
              borderRadius:'20%',
                width: '350px',
                height: '350px',
          }}
            >
            {
                units.map((unit, index) => {
                  // let i = Number(index) + 1;
                  
                  if(units.length <= index + 1){
                    i = 0
                  }else{
                    i = index + 1
                  }
                  // if(index == 0){
                  //   i = 1
                  // }else if(index == 1){
                  //   i = 2
                  // }


                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                    className='text-center'
                    variant='dark'
                    style={{
                    //   height:window.innerWidth > 450? 700 : 600,
                    borderRadius:'20%',
                    width: '300px',
                    // height: '330px',
                    // backgroundColor: 'navy',
                      
                  }}
                    >
                    {/* <span className='col-4'> */}
                    <div>
                        <img src={units[i].img} width={'300px'} height={'330px'} 
                          style={{ 
                            borderRadius: '20%'
                            }}
                          />
                      </div>
                      <h3> {units[i].title} </h3>
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>

        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider my-3 col-lg-4 col-md-4 col-sm-6 col-xs-12'
            style={{
              borderRadius:'20%',
                width: '350px',
                height: '350px',
          }}
            >
            {
                units.map((unit, index) => {
                  // let i = Number(index) + 1;
                  
                  if(units.length <= index + 2){
                    i = 1
                  }else{
                    i = index + 2
                  }
                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                    className='text-center'
                    variant='dark'
                    style={{
                    //   height:window.innerWidth > 450? 700 : 600,
                    borderRadius:'20%',
                    width: '300px',
                    // height: '330px',
                    // backgroundColor: 'navy',
                      
                  }}
                    >
                    {/* <span className='col-4'> */}
                    <div>
                        <img src={units[i].img} width={'300px'} height={'330px'} 
                          style={{ 
                            borderRadius: '20%'
                            }}
                          />
                    </div>
                    <h3> {units[i].title} </h3>
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>



    </div>
  )
}

export default Units